export const dashboardConstants = {
    GET_DASHBOARD_CREATORS: 'GET_DASHBOARD_CREATORS',
    GET_DASHBOARD_CHARTS_DATA: 'GET_DASHBOARD_CHARTS_DATA',
    GET_DASHBOARD_DELIVERIES: 'GET_DASHBOARD_DELIVERIES',
};
